import { FontAwesomeIcon } from "./FontAwesomeIcon"
import { faUserPlus } from "@fortawesome/free-solid-svg-icons"

export const UserPlus = (props) => {
  return <FontAwesomeIcon faIcon={faUserPlus} {...props} />
}
